export default "__VITE_ASSET__DBD9UDIj__"